import React, { useState, useEffect } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function ReviewsPanel({ theme }) {
  const light = theme === 'light';
  const [data, setData] = useState(null);
  useEffect(() => {
    axios.get(`${API}/admin/reviews`, { withCredentials: true }).then(r => setData(r.data)).catch(() => {});
  }, []);
  if (!data) return <p className={light ? 'text-gray-500' : 'text-white/50'}>Chargement…</p>;
  const { items, counts } = data;
  return (
    <div data-testid="reviews-panel">
      <div className="flex gap-3 mb-5 flex-wrap">
        {[['Demandes envoyées', counts.sent], ['Notes reçues', counts.rated], ['Avec commentaire', counts.with_comment], ['Note moyenne', counts.avg ? `${counts.avg} / 5` : '—']].map(([l, v]) => (
          <div key={l} className={`rounded-lg px-4 py-3 ${light ? 'bg-gray-100' : 'bg-white/5'}`}>
            <div className={`text-xs uppercase ${light ? 'text-gray-500' : 'text-white/45'}`}>{l}</div>
            <div className={`text-xl font-bold ${light ? 'text-gray-900' : 'text-white'}`}>{v}</div>
          </div>
        ))}
      </div>
      <div className={`rounded-lg overflow-hidden ${light ? 'bg-white border border-gray-200' : 'bg-white/5'}`}>
        <table className="w-full text-sm">
          <thead>
            <tr className={light ? 'text-gray-500 border-b border-gray-200' : 'text-white/45 border-b border-white/10'}>
              {['Date', 'Abonné', 'Contenu', 'Note', 'Commentaire'].map(h => <th key={h} className="text-left px-4 py-3 font-semibold">{h}</th>)}
            </tr>
          </thead>
          <tbody>
            {items.length === 0 && <tr><td colSpan={5} className={`px-4 py-6 text-center ${light ? 'text-gray-400' : 'text-white/40'}`}>Aucune demande d'avis envoyée pour le moment</td></tr>}
            {items.map(i => (
              <tr key={i.id} data-testid={`review-row-${i.id}`} className={light ? 'border-b border-gray-100' : 'border-b border-white/5'}>
                <td className={`px-4 py-3 whitespace-nowrap ${light ? 'text-gray-500' : 'text-white/50'}`}>{(i.rated_at || i.created_at || '').slice(0, 16).replace('T', ' ')}</td>
                <td className={`px-4 py-3 ${light ? 'text-gray-900' : 'text-white'}`}>{i.name || i.email}<div className={`text-xs ${light ? 'text-gray-400' : 'text-white/35'}`}>{i.email}</div></td>
                <td className={`px-4 py-3 font-semibold ${light ? 'text-gray-900' : 'text-white'}`}>{i.content_title}</td>
                <td className="px-4 py-3 whitespace-nowrap">
                  {i.stars ? <span className="text-[#E9641A]">{'★'.repeat(i.stars)}<span className={light ? 'text-gray-300' : 'text-white/20'}>{'★'.repeat(5 - i.stars)}</span></span>
                    : <span className={light ? 'text-gray-400' : 'text-white/35'}>En attente</span>}
                </td>
                <td className={`px-4 py-3 ${light ? 'text-gray-700' : 'text-white/70'}`}>{i.comment || '—'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
